var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEliminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e353b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.43,32.38l-.85-2.28c-.91-2.45-3.28-4.1-5.89-4.1h-13.95v-3.51c0-2.86-2.32-5.18-5.18-5.18h-11.09c-2.86,0-5.18,2.32-5.18,5.18v3.51h-13.93c-2.6,0-4.9,1.57-5.85,3.99l-.9,2.3c-.57,1.45-.38,3.09,.49,4.38,.88,1.29,2.33,2.06,3.89,2.06h2.16l3.29,48.13c.22,3.26,2.96,5.82,6.23,5.82h32.2c3.29,0,6.03-2.58,6.24-5.87l2.95-48.08h.94c1.54,0,2.99-.76,3.87-2.02s1.09-2.89,.55-4.33Zm-12.11,54.21c-.08,1.29-1.15,2.3-2.44,2.3H39.68c-1.28,0-2.35-1-2.44-2.28l-3.27-47.71,43.29-.15-2.94,47.84ZM48.09,22.5c0-.76,.62-1.38,1.38-1.38h11.09c.76,0,1.38,.62,1.38,1.38v3.51h-13.85v-3.51Zm34.67,12.04c-.1,.15-.33,.39-.75,.39H27.99c-.42,0-.65-.25-.75-.4-.1-.15-.25-.46-.1-.85l.9-2.3c.38-.96,1.28-1.58,2.31-1.58h49.33c1.03,0,1.97,.65,2.33,1.62l.85,2.28c.14,.39,0,.69-.11,.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.57,79.72s.06,0,.09,0c1.05-.05,1.86-.94,1.81-1.99l-1.47-32.1c-.05-1.05-.94-1.85-1.98-1.81-1.05,.05-1.86,.94-1.81,1.99l1.47,32.1c.05,1.02,.89,1.81,1.9,1.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.94,79.72h.02c1.04,0,1.89-.84,1.9-1.88l.4-32.1c.01-1.05-.83-1.91-1.88-1.92h-.02c-1.04,0-1.89,.84-1.9,1.88l-.4,32.1c-.01,1.05,.83,1.91,1.88,1.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.3,79.72s.06,0,.1,0c1.01,0,1.85-.79,1.9-1.8l1.62-32.1c.05-1.05-.75-1.94-1.8-1.99-1.03-.06-1.94,.75-1.99,1.8l-1.62,32.1c-.05,1.05,.75,1.94,1.8,1.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminar);
export default __webpack_public_path__ + "static/media/eliminar.af7a1fc92bd828a5ba356da77d992340.svg";
export { ForwardRef as ReactComponent };